
const data = {
	info: {
		label: "marseille",
		aasqasLabel: "AtmoSud pour la région Provence-Alpes-Côte d'Azur",
		aasqasUrl: "https://opendata.atmosud.org/",
		ctaUrl: "https://act.greenpeace.org/page/38694/action/1",
		ctaLabel: "Interpellez vos élus",
		blogUrl: "https://www.greenpeace.fr/marseille-les-ecoles-et-creches-cernees-par-la-pollution-de-lair/",
		reportUrl: "https://docs.google.com/forms/d/e/1FAIpQLScManKaUe-zagUR7RZwvSqwxTx0qoVnvoQlO8R2XaT6YH1TJQ/viewform",
	},
	bounds: [
		[43.35338206931962, 5.316696166992188],
		[43.25764801404812, 5.442352294921876 ]
	],
	minZoom: 6,
	maxZoom: 18,
	gradient: [
		// https://geoservices.atmosud.org/geoserver/mod_sudpaca_2017/ows?service=WMS&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=mod_sudpaca_2017_no2_moyan
		{color: '#00ccaa', value: 0},
		{color: '#ccf200', value: 20},
		{color: '#ff0000', value: 40},
		{color: '#bf0000', value: 60},
		{color: '#800000', value: "80+"},
	],
	wms: {
		//url: 'http://geoservices.atmosud.org/geoserver/mod_sudpaca_2017/ows?',
		url: 'https://proxy.greenpeace.fr/marseille/{z}/{x}/{y}',
		params: {
			layers: "mod_sudpaca_2017_no2_moyan", //"mod_sudpaca_2017:mod_sudpaca_2017_isa_an",
			mapservice: "WMS",
			srs: "EPSG:2154",
			format: "image/png"
		},
	},
	attribution: [
		'<a href="https://www.greenpeace.fr" target="_blank">Greenpeace</a>',
		'<a href="https://www.atmosud.org/" target="_blank">ATMO Sud</a>',
	],

};

export default data;